module.exports = __webpack_public_path__ + "fonts/rubik-regular-webfont.8e2b729c.8e2b729c.woff";